import { render, staticRenderFns } from "./PowerGrammarFixRight.vue?vue&type=template&id=1a716368&scoped=true"
import script from "./PowerGrammarFixRight.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a716368",
  null
  
)

export default component.exports